export default "__VITE_ASSET__BxYGW0c2__"